import { translate } from "@escapio/shared/l10n/translate";

export const ALL = "all";
export const MIN_3_STAR = "min_3_star";
export const MIN_4_STAR = "min_4_star";
export const ONLY_5_STAR = "only_5_star";

export const isValid = classification => classification in OPTIONS;

export const isAtLeast = (target, subjectValue) =>
	subjectValue >= OPTIONS[target];

export const OPTIONS = {
	[ALL]: 0,
	[MIN_3_STAR]: 3,
	[MIN_4_STAR]: 4,
	[ONLY_5_STAR]: 5,
};

export const SHORT_LABELS = {
	[ALL]: "0+",
	[MIN_3_STAR]: "3",
	[MIN_4_STAR]: "4",
	[ONLY_5_STAR]: "5",
};

export const LONG_LABELS = {
	[ALL]: translate("filter_classification_label_all"),
	[MIN_3_STAR]: translate("filter_classification_label_3_star"),
	[MIN_4_STAR]: translate("filter_classification_label_4_star"),
	[ONLY_5_STAR]: translate("filter_classification_label_5_star"),
};

export const TRACKING_LABELS = {
	[ALL]: "alle",
	[MIN_3_STAR]: "ab 3 Sterne",
	[MIN_4_STAR]: "ab 4 Sterne",
	[ONLY_5_STAR]: "5 Sterne",
};
